import { useMemo } from 'react';
import { useAppUser } from '@bechtel/client-common';
import { AuthPermission, AuthScope } from '@bechtel/types';

export function useTimesheetPermissions() {
  const { hasPermissionScope } = useAppUser();
  const timesheetPermissions = useMemo(() => {
    const canViewTimesheet = hasPermissionScope({
      permission: AuthPermission.VIEW_TIMESHEETS,
      scope: AuthScope.APPLICATION,
    });
    return { canViewTimesheet };
  }, [hasPermissionScope]);
  return timesheetPermissions;
}
